class LanguageSwitcher extends HTMLElement 
{
  constructor () {
    super();

    this.currrentLanguage = Shopify.locale;
    this.init();
  }

  init () {
    window.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.language-switcher').forEach(languageSwitcher => {
        this.initLanguageSelector(languageSwitcher);  
      })
    });
  }
  
  initLanguageSelector (languageSwitcher) {
    const langItem = languageSwitcher.querySelectorAll('.lang-item');
    const buttonSwitcher = languageSwitcher.querySelector('.button-lang-switcher');
    const wrapperSwitcher = languageSwitcher.querySelector('.language-switcher-wrapper');
    const height = wrapperSwitcher.scrollHeight;

    buttonSwitcher.addEventListener('click', (e) => {
        if(wrapperSwitcher.classList.contains('open')) {
            wrapperSwitcher.classList.remove('open');
            wrapperSwitcher.style.setProperty('height', '0px');
            wrapperSwitcher.style.setProperty('border', '1px solid transparent');
        } else {
            wrapperSwitcher.classList.add('open');
            wrapperSwitcher.style.setProperty('height', height + 'px');
            wrapperSwitcher.style.setProperty('border', '1px solid #ffffff');
        }
    })
    
    langItem.forEach(element => {
      element.addEventListener('click', () => {
        const selectedLang = element.dataset.lang; 
        const currentPath = window.location.pathname.split('/').filter(Boolean); 
        let marketSegment = '';
        let newPath = `/${selectedLang}`;
    
        if (currentPath[0] && currentPath[0].includes('-')) {
          marketSegment = currentPath[0].split('-')[1]; 
        }
  
        if (marketSegment == "") {
          if(currentPath[0] != "fr" && currentPath[0] != "de") {
            if(selectedLang == "en") {
              newPath = '/' + currentPath.join('/');
            } else {
              if (currentPath.length > 1) {
                newPath += '/' + currentPath.join('/');
              }
            }
          } else {
            if(selectedLang == "en") {
              newPath = '/' + currentPath.slice(1).join('/');
            } else {
              if (currentPath.length > 1) {
                newPath += '/' + currentPath.slice(1).join('/');
              }
            }
          }
        } else {
          newPath += '-' + marketSegment;
          if (currentPath.length > 1) {
            newPath += '/' + currentPath.slice(1).join('/');
          }
        }
        
        window.location.href = newPath; 
      });
    });    
  }
}

customElements.define('language-switcher', LanguageSwitcher)